var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild, Input } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { Subscription } from 'rxjs';
import { Message } from '../../common/dialog/mensaje.component';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { UuidParteService } from '../../services/uuidparte.service';
var form;
var UuidParteViewComponent = (function () {
    function UuidParteViewComponent(_comService, _uuidParteService, router, route) {
        this._comService = _comService;
        this._uuidParteService = _uuidParteService;
        this.router = router;
        this.route = route;
        this.subscription = new Subscription();
        this.subscription2 = new Subscription();
        this.mensajeZocalo = "";
        this.mostrarZocalo = false;
        this.permisoPartes = true;
        this.noEsOculto = true;
        this.isCollapsedContent = false;
        this.uuidParActivo = false;
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    UuidParteViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._comService.emitBlocking(true);
        this.route.params.subscribe(function (params) {
            _this.uuidParCod = params['uuidParCod'];
            _this.verificarUuidParte();
        });
    };
    UuidParteViewComponent.prototype.verificarUuidParte = function () {
        var _this = this;
        this._uuidParteService.findUuidPar(this.uuidParCod).subscribe(function (response) {
            if (response) {
                _this.uuidParte = response;
                //console.log("uuidParte: " + JSON.stringify(this.uuidParte));
                _this.noEsOculto = true;
                if (_this.uuidParte.uuidParActivoDesde != null && _this.uuidParte.uuidParActivoDesde != '') {
                    _this.mostrarZocalo = true;
                    _this.mensajeZocalo = "Fecha de vinculación: " + _this.uuidParte.uuidParActivoDesde;
                }
                else {
                    _this.mostrarZocalo = false;
                    _this.mensajeZocalo = "";
                }
                _this.uuidParActivo = _this.uuidParte.uuidParActivo;
                _this._comService.emitBlocking(false);
                if (!_this.uuidParActivo) {
                    _this.router.navigate(['/desvinculacion-rep']);
                }
            }
            else {
                _this._comService.emitBlocking(false);
                //no existe el uuid
                _this.router.navigate(['/enlace-no-autorizado']);
            }
        }, function (error) {
            _this._comService.emitBlocking(false);
            _this.router.navigate(['/enlace-no-autorizado']);
        });
    };
    UuidParteViewComponent.prototype.getStyleParte = function (nav) {
        var classes = "tab-pane";
        if (nav) {
            classes = "nav-link";
        }
        if (this.permisoPartes) {
            classes = "active " + classes;
        }
        return classes;
    };
    return UuidParteViewComponent;
}());
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], UuidParteViewComponent.prototype, "msgPopup", void 0);
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], UuidParteViewComponent.prototype, "msgPopupAct", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UuidParteViewComponent.prototype, "expId", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UuidParteViewComponent.prototype, "mensajeZocalo", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UuidParteViewComponent.prototype, "mostrarZocalo", void 0);
UuidParteViewComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'uuid-parte-view',
        templateUrl: 'uuid-parte-view.component.html',
    }),
    __metadata("design:paramtypes", [CommonService,
        UuidParteService,
        Router,
        ActivatedRoute])
], UuidParteViewComponent);
export { UuidParteViewComponent };
//# sourceMappingURL=uuid-parte-view.component.js.map